import type { Auth0User, QuoteDocument } from 'paintscout'
import moment from 'moment'
const format = 'YYYY-MM-DD HH:MM:SS'

export function getDebugInfo({ user, quote }: { user?: Auth0User; quote?: QuoteDocument }) {
  const status = {
    value: quote?.status?.value,
    updated: formatDate(quote?.status?.updated),
    history: Object.keys(quote?.status?.history ?? {}).reduce((acc, key) => {
      return {
        ...acc,
        [key]: formatDate(quote.status.history[key].timestamp)
      }
    }, {})
  }

  const dates = {
    created: formatDate(quote?.dates?.created),
    updated: formatDate(quote?.dates?.updated)
  }
  return {
    companyId: user?.app_metadata?.companyId,
    user: {
      user_id: user?.user_id,
      email: user?.email,
      roles: user?.app_metadata?.roles
    },
    quote: {
      _id: quote?._id,
      _rev: quote?._rev,
      version: quote?.version,
      quoteType: quote?.int_ext?.value,
      quoteDate: quote?.quote_date,
      number: quote?.number,
      isInvoice: !!quote?.is_invoice,
      owner: quote?.owner?.id,
      contactId: quote?.contact?.id,
      subtotal: quote?.totals?.price,
      after_tax: quote?.totals?.after_tax,
      status,
      dates,
      urls: quote?.urls,
      template: quote?.fromTemplate?.key
    }
  }
}

function formatDate(date) {
  if (!date) {
    return
  }

  return moment(date).format(format)
}
